import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Container} from '@modifi/ui'

import {Audio} from './styles'
import {DefaultComponentWrapper} from '../common'

const propTypes = {
  audioUrl: PropTypes.string,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  audioUrl: '',
  backgroundColor: undefined,
}

export type AudioComponentProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const AudioComponent: React.FC<AudioComponentProps> = ({audioUrl, backgroundColor}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor} padding={0}>
    <Container>
      {audioUrl && (
        <Audio controls data-testid="audio-element">
          <source src={audioUrl} type="audio/mpeg" />
          <source src={audioUrl} type="audio/ogg" />
          <source src={audioUrl} type="audio/wav" />
        </Audio>
      )}
    </Container>
  </DefaultComponentWrapper>
)

AudioComponent.propTypes = propTypes

AudioComponent.defaultProps = defaultProps

export default AudioComponent
